import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "onClick", "onKeyDown", "tabIndex"],
    _excluded2 = ["component"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef, useCallback } from 'react';

var isNativeButton = function isNativeButton(el) {
  return el.nodeName === 'BUTTON' || el.nodeName === 'A' && el.getAttribute('href');
};
/**
 * Keyword navigation for non native elements:
 * - Enter will trigger click event
 *
 * Adds aria attributes:
 * - `aria-disabled`
 */


export var useAbstractButton = function useAbstractButton(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleKeyDown = useCallback(function (event) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);

    if (event.target === event.currentTarget && !disabled && !isNativeButton(event.target) && event.key === 'Enter') {
      event.preventDefault();
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
  }, [onClick, disabled, onKeyDown]);
  return _objectSpread({
    onKeyDown: handleKeyDown,
    onClick: onClick,
    disabled: disabled,
    tabIndex: disabled ? -1 : tabIndex,
    'aria-disabled': disabled ? disabled : void 0
  }, rest);
};
var AbstractButton = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _ref2$component = _ref2.component,
      ButtonComponent = _ref2$component === void 0 ? 'button' : _ref2$component,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var props = useAbstractButton(_objectSpread({
    ref: ref
  }, rest));
  return /*#__PURE__*/React.createElement(ButtonComponent, props);
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
AbstractButton.displayName = 'AbstractButton';
export default AbstractButton;